import { StandardText, brandfolderColorPalette } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { BackButton } from '../common/BackButton';
import { PoweredByAiBadge } from '../common/PoweredByAiBadge';

const PeoplePageHeaderWrapper = styled.div`
  margin: 40px 0;
`;
const PageTitleWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 24px;

  h1 {
    margin-right: 6px;
  }
`;
const Subtext = styled(StandardText)`
  p {
    color: ${brandfolderColorPalette.neutrals[700]};
    font-weight: 450;
    line-height: 20px;
  }
`;
const TitleDivider = styled.hr`
  margin: 40px 0;
`;

export const PeoplePageHeader: FunctionComponent = () => {
  const navigate = useNavigate();
  return (
    <PeoplePageHeaderWrapper>
      <PageTitleWrapper>
        <h1>
          <Trans>People</Trans>
        </h1>
        <PoweredByAiBadge />
      </PageTitleWrapper>
      <Subtext>
        <Trans>People from this Brandfolder’s photos are added to this gallery once a day.</Trans>
      </Subtext>
      <TitleDivider />
      <BackButton handleNavigateBack={(): void => {
        navigate(`/${BFG.brandfolder_slug}`);
      }} />
    </PeoplePageHeaderWrapper>
  );
};
